$(document).ready(function () {
    const mainNavItems = $('.has-mega-menu > ul > li:not(.hide-menu-on-desktop)');
    let isMobile = isViewportMobile();
    let megaMenuItems = $(filterMegaMenuItems(mainNavItems));
    let megaWrapper = $('.header__bottom')[0];

    if(megaMenuItems) {
        megaMenuItems.each(function () {
            setUpMegaMenuBehaviour($(this), isMobile, megaMenuItems);
        });

        if(isMobile) {
            addScrollbar(megaWrapper);
        };

        window.addEventListener("resize", function () {
            let isMobileAfterResize = isViewportMobile();

            if(isMobile != isMobileAfterResize) {
                isMobile = isMobileAfterResize;

                clearMegaMenuSetup();

                megaMenuItems.each(function () {
                    setUpMegaMenuBehaviour($(this), isMobile, megaMenuItems);
                });

                if(isMobile && !megaWrapper.scrollbar) {
                    addScrollbar(megaWrapper);
                };
            }
        });
    }
});

function clearMegaMenuSetup() {
    $("html").removeClass("menu_open");
    $("header.global .active").each(function() {
        this.classList.remove("active");
    });
    $("header.global .ps, header.global .ps--active-y").each(function() {
        removeScrollbar(this);
    });
}

function isViewportMobile() {
    return window.innerWidth < 900;
};

function filterMegaMenuItems(collection) {
    let items = [];
    collection.each(function () {
        if (!hasMegaMenu(this)) {
            $(this).addClass('no-dropdown');
        } else {
            items.push(this);
        }
    });
    return items;
}

function hasMegaMenu(parent) {
    return $(parent).children('.mega').length > 0;
}

function addScrollbar(element) {
    if(element) {
        element.scrollbar = new PerfectScrollbar(element, {
            wheelPropagation: false,
            minScrollbarLength: 150,
            maxScrollbarLength: 150,
            suppressScrollX: true,
            swipeEasing: true
        });
    }
}

function removeScrollbar(element) {
    if(element) {
        element.scrollTop = 0;
        element.scrollbar.destroy();
        element.scrollbar = null;
        $(element).children('.ps__rail-x, .ps__rail-y').remove();
    }
}

function setUpMegaMenuBehaviour($mainNavItem, isMobile, megaMenuItems) {
    const
        delay = 100,
        $fullMenu = $mainNavItem.children('.mega').eq(0),
        $fullMenuBack = $fullMenu.children('.mega__back'),
        $megaList = $fullMenu.children('.mega__list'),
        $megaHeader = $fullMenu.children('.mega__header--primary'),
        $megaIntro = $fullMenu.children('.mega__intro'),
        $firstLevelItems = $megaList.children().children(':first-child'),
        $firstLevelItemsParents = $firstLevelItems.parent(),
        $firstLevelBackBtn = $firstLevelItemsParents.children().children('.mega__back'),
        $firstItemFirstLevel = $firstLevelItems.eq(0),
        $secondLevelItems = $firstLevelItems.siblings('.mega__sublist').children().children(':first-child'),
        $secondLevelItemsParents = $secondLevelItems.parent(),

        $isProductCatalogue = $('.mega--product').length,
        $prodCat1stLvlBackBtn = $fullMenu.children('.mega__list').children('.mega__back'),
        $prodCatItems = $fullMenu.find('.mega__list--pc').children('li'),
        $prodCatBackBtns = $fullMenu.find('.mega__list--pc').find('.mega__back'),

        $megaWrapper = $('.header__bottom')[0];

    let isHoverable = $mainNavItem.hasClass("no-delay");
    let btn = $mainNavItem.find(".header__bottom-list-button");
    let timer;

    /* VIEWPORT IS DESKTOP */
    if (!isMobile) {
        $firstItemFirstLevel.parent().addClass('active');

        if($isProductCatalogue) {
            $prodCat1stLvlBackBtn.unbind("click");
            $prodCatItems.unbind("click");
            $prodCatBackBtns.unbind("click");

            $mainNavItem.hover(function () {
                $prodCatItems.removeClass('active');
                $megaIntro.addClass('active');
            });

            $prodCatItems.on('mouseenter', function () {
                const _this = this;
                timer = setTimeout(function () {
                    if($(_this).parent().parent().parent().hasClass("mega--product")) {
                        $(_this).children().children().find(".active").removeClass("active");
                    }
                    $(_this).siblings().removeClass('active');
                    $megaIntro.removeClass('active');
                    $(_this).addClass('active');
                }, delay);
            }).on('mouseleave', function () {
                clearTimeout(timer);
            });

            $megaHeader.hover(function () {
                $prodCatItems.removeClass('active');
                $megaIntro.addClass('active');
            });
        } else {
            $fullMenuBack.unbind("click");
            $firstLevelItems.unbind("click");
            $firstLevelBackBtn.unbind("click");

            if(isHoverable) {
                $mainNavItem.hover(handleNavItemHover);
            } else {
                btn.click(handleButtonClick);
            }

            $megaHeader.hover(function () {
                $firstLevelItemsParents.removeClass('active');
                $secondLevelItemsParents.removeClass('active');
                $megaIntro.addClass('active');
            });

            $firstLevelItems.on('mouseenter', function () {
                const _this = this;
                timer = setTimeout(function () {
                    $firstLevelItemsParents.removeClass('active');
                    $secondLevelItemsParents.removeClass('active');
                    $megaIntro.removeClass('active');
                    $(_this).parent().addClass('active');
                }, delay);
            }).on('mouseleave', function () {
                clearTimeout(timer);
            });

            $secondLevelItems.on('mouseenter', function (event) {
                const _this = this;
                timer = setTimeout(function () {
                    $secondLevelItemsParents.removeClass('active');
                    $(_this).parent().addClass('active');
                    event.stopPropagation();
                }, delay);
            }).on('mouseleave', function () {
                clearTimeout(timer);
            });
        }
    /* VIEWPORT IS MOBILE */
    } else {
        $mainNavItem.unbind("hover");
        $megaHeader.unbind("hover");

        $mainNavItem.click(function () {
            $mainNavItem.addClass('active');
            $mainNavItem.focus();
            removeScrollbar($(this).closest('.ps, .ps--active-y')[0]);
            addScrollbar($(this).children('.mega')[0]);
            event.stopPropagation();
        });

        if($isProductCatalogue) {
            $prodCatItems.unbind("hover");

            $prodCat1stLvlBackBtn.click(function () {
                $mainNavItem.removeClass('active');
                removeScrollbar($mainNavItem.children('.ps, .ps--active-y')[0]);
                addScrollbar($megaWrapper);
                event.stopPropagation();
            });

            $prodCatItems.click(function () {
                $(this).addClass('active');
                $(this).focus();
                removeScrollbar($(this).closest('.ps, .ps--active-y')[0]);
                addScrollbar($(this).children('.mega__sublist')[0]);
                event.stopPropagation();
            });

            $prodCatBackBtns.click(function () {
                let scrollbar = $(this).closest('.ps, .ps--active-y');
                $(this).parent().parent().removeClass('active');
                addScrollbar(scrollbar.parent().closest('.mega__sublist, .mega')[0]);
                removeScrollbar(scrollbar[0]);
                event.stopPropagation();
            });
        } else {
            $firstLevelItems.unbind("hover");
            $secondLevelItems.unbind("hover");

            $fullMenuBack.click(function () {
                $mainNavItem.removeClass('active');
                removeScrollbar($mainNavItem.children('.ps, .ps--active-y')[0]);
                addScrollbar($megaWrapper);
                event.stopPropagation();
            });

            $firstLevelItems.click(function () {
                $(this).parent().addClass('active');
                $(this).parent().focus();
                removeScrollbar($(this).parent().closest('.ps, .ps--active-y')[0]);
                addScrollbar($(this).siblings('.mega__sublist')[0]);
                event.stopPropagation();
            });

            $firstLevelBackBtn.click(function() {
                $firstLevelItemsParents.removeClass('active');
                removeScrollbar($(this).closest('.ps, .ps--active-y')[0]);
                addScrollbar($(this).closest('.mega')[0]);
                event.stopPropagation();
            });
        }
    }

    function handleNavItemHover() {
        $firstLevelItemsParents.removeClass('active');
        $secondLevelItemsParents.removeClass('active');
        $megaIntro.addClass('active');
    }

    function handleButtonClick() {
        if($mainNavItem.hasClass('active')) {
            $mainNavItem.removeClass('active');
        } else {
            megaMenuItems.removeClass('active');
            $firstLevelItemsParents.removeClass('active');
            $secondLevelItemsParents.removeClass('active');
            $megaIntro.addClass('active');
            $mainNavItem.addClass('active');
        }
    }
}